import React from 'react';
import canopyUrls from 'canopy-urls!sofe';
import { CpButton, CpIcon, constants } from 'canopy-styleguide!sofe';
import { featureEnabled } from 'feature-toggles!sofe';

import { ensurePageReload } from 'src/common/url-helpers';
import styles from './nav-profile.styles.css';

export const NavProfileDefaultContent = (props) => {
const {
  setReferralDialog,
  notificationCount,
  setSwitchingUser,
  close,
  userHasAccess,
  userId,
  hasAlternateEntities,
} = props
  const supportPhone = constants.canopyPhone;

  return (
    <div onClick={close}>
      <div className={styles.chatWithSupport}>
        <CpButton
          block
          id={featureEnabled('toggle_zendesk_chat') ? 'canopy-zendesk-launcher' : 'canopy-intercom-launcher'}
          btnType="primary"
          className={styles.supportChat}
        >
          Chat with Support
        </CpButton>
        <div className={styles.supportPhone}>or call at {supportPhone}</div>
      </div>
      <div className="cp-select-list cp-select-list__primary-menu">
        <div className="cp-divider" />
        <a
          className={styles.profileLink}
          href="https://support.getcanopy.com/hc/en-us"
          target="_blank"
          rel="noreferrer noopener"
        >
          <div className="cp-select-list__content">Search support library</div>
          <CpIcon name="caret-large-right" className="cp-select-list__icon-right" />
        </a>
        <button onClick={() => setReferralDialog(true)}>
          <div className="cp-select-list__content">Make a referral</div>
          <CpIcon name="caret-large-right" className="cp-select-list__icon-right" />
        </button>
        <a href="https://community.canopytax.com/" target="_blank">
          <div className="cp-select-list__content">Ask our community</div>
          <CpIcon name="caret-large-right" className="cp-select-list__icon-right" />
        </a>
        <a
          href="/wg/uservoice-redirect"
          target="_blank"
          rel="noreferrer noopener"
        >
          <div className="cp-select-list__content">Suggest a feature</div>
          <CpIcon name="caret-large-right" className="cp-select-list__icon-right" />
        </a>
        <a
          href="https://support.getcanopy.com/hc/en-us/categories/9623317466011-Canopy-Updates"
          target="_blank"
          rel="noreferrer noopener"
        >
          <div className="cp-select-list__content">Release notes</div>
          <CpIcon name="caret-large-right" className="cp-select-list__icon-right" />
        </a>
        <div className="cp-divider" />
        <a href="#/notifications/dashboard">
          <div className="cp-select-list__content">Notifications</div>
          {notificationCount && (
            <div className={styles.notificationCount}>
              {notificationCount}
            </div>
          )}
        </a>
        {userHasAccess(['company_settings_activity_log']) && (
          <a href="#/activity-log">
            Activity log
          </a>
        )}
        <a href={`#/global-settings/user/${userId}`}>
          Settings
        </a>
        {userHasAccess(['canopy_admin', 'canopy_users', 'canopy_trials']) && (
          <a href="#/canopy-admin/users">
            Canopy Admin
          </a>
        )}
        {hasAlternateEntities && (
          <button onClick={(e) => {
            e.stopPropagation()
            setSwitchingUser(true)
          }}>
            <div className="cp-select-list__content">Switch accounts</div>
            <CpIcon name="caret-large-right" className="cp-select-list__icon-right" />
          </button>
        )}
        <a
          href={ensurePageReload(
            `${canopyUrls.getAuthUrl()}/#/logout?redirect_url=${encodeURIComponent(window.location.origin)}`,
          )}
        >
          Sign out
        </a>
      </div>
    </div>
  )
}
